import React, { useContext } from "react";

interface IReferralParentLogintate {

};

const ReferralParentLoginContext = React.createContext({} as IReferralParentLogintate);

const ReferralParentLoginProvider = ({ children }: any) => {
    const ReferralParentLoginState: IReferralParentLogintate = {};
    return (
        <ReferralParentLoginContext.Provider value={ReferralParentLoginState}>
            { children } 
        </ReferralParentLoginContext.Provider>
    );
}

export const useReferralParentLoginState = () => {
    const context = useContext(ReferralParentLoginContext);
    if (!context) {
        throw Error(`Use ${useReferralParentLoginState.name} in ${ReferralParentLoginContext.displayName}`);
    }
    return context;
};

export default ReferralParentLoginProvider;